import { render, staticRenderFns } from "./ClientSettlements.vue?vue&type=template&id=2e688d6c&scoped=true&"
import script from "./ClientSettlements.vue?vue&type=script&lang=js&"
export * from "./ClientSettlements.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettlements.vue?vue&type=style&index=0&id=2e688d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e688d6c",
  null
  
)

export default component.exports